// import React, { useEffect, useState } from "react";
// import TitleSection from "../../../../../Shared/TitleSection/TitleSection";
// import useApiRequest from "../../../../../Hooks/apiReq";
// import { convertToINRFormat } from "../../../../../Utils/INRConvert";
// import Loader from "../../../../../CommonComponets/Loader";
// const MyRankOrg = () => {
//   const [myRanksData, setMyRank] = useState([
//     {
//       RankName: "Silver Director",
//       Status: "Pending", // or "Active" or "Achived"
//       DisplayAmt: "10,000", // Formatted amount shown on the left
//       TargetAmt: 50000, // Required for next rank (used in 'sm' card logic)
//       TotalBusiAchived: 25000, // Amount achieved so far (used in 'sm' card logic)
//       RequiredBusiness: 25000, // Remaining amount (Target - Achieved)
//       Remark: "Next success is just a few steps away!", // Optional description text
//     },
//     {
//       RankName: "Gold Director",
//       Status: "Active",
//       DisplayAmt: "25,000",
//       TargetAmt: 100000,
//       TotalBusiAchived: 50000,
//       RequiredBusiness: 50000,
//       Remark: "Great job! Keep going.",
//     },
//     {
//       RankName: "Diamond Director",
//       Status: "Achived",
//       DisplayAmt: "50,000",
//       TargetAmt: 200000,
//       TotalBusiAchived: 200000,
//       RequiredBusiness: 0,
//       Remark: "Congratulations!",
//     },
//   ]);
//   const {
//     error,
//     loading,
//     response,
//     sendApiRequest: SendRequistApiRank,
//   } = useApiRequest();
//   useEffect(() => {
//     SendRequistApiRank("POST", "/Reports/GetAssociateRank", "", {
//       onSuccess: (res) => {
//         const ParsedData = res?.data?.jsonData
//           ? JSON.parse(res?.data?.jsonData)
//           : [];
//         setMyRank(ParsedData);
//         // console.log("MyRank", ParsedData);
//       },
//     });
//   }, []);

//   //   if (error) {
//   //     return (
//   //       <div className="content">
//   //         <p className="p fs-6 text-danger text-center">{error}</p>
//   //       </div>
//   //     );
//   //   }
//   if (loading) {
//     return <Loader />;
//   }
//   return (
//     <div className="content">
//       <div className="row">
//         <div className="col-12">
//           <div className=" my-2 px-2">
//             <TitleSection text={"My Rank"} />
//           </div>
//           <div className="card p-2">
//             <div className="text-center h3">Your journey is unstoppable</div>
//             <div className=" text-center h5 ">
//               {" "}
//               next succes is just a few steps away!
//             </div>
//             <div className=" my-rank-box d-flex align-item-center flex-column m-auto ">
//               <ul className="">
//                 {myRanksData?.length > 0
//                   ? myRanksData.map((item, index, array) => {
//                       const prev = index > 0 ? array[index - 1] : null;
//                       return item.Status == "Pending" ? (
//                         <li className="ssm" key={index}>
//                           <div
//                             className={
//                               prev?.Status == "Active"
//                                 ? "cr-left-active"
//                                 : "cr-left"
//                             }
//                           >
//                             <span>{item?.DisplayAmt}</span>
//                           </div>
//                           <div className="cr-right">
//                             <span
//                               className={
//                                 prev?.Status == "Active" ? "greencolor" : ""
//                               }
//                             >
//                               {item?.RankName}
//                             </span>
//                             <p
//                               className={
//                                 prev?.Status == "Active" ? "greencolor" : ""
//                               }
//                             >
//                               {item?.Remark}
//                             </p>
//                           </div>
//                         </li>
//                       ) : item.Status == "Achived" ? (
//                         <li className="active" key={index}>
//                           <div className="cr-left">
//                             <span className="headingColor fw-bold ">
//                               {item?.DisplayAmt}
//                             </span>
//                           </div>
//                           <div className="cr-right">
//                             <span>{item?.RankName}</span>
//                             <p>{item?.Remark}</p>
//                           </div>
//                         </li>
//                       ) : (
//                         item.Status == "Active" && (
//                           <>
//                             <li className="active text-success " key={index}>
//                               <div className="cr-leftactive cr-left  text-success ">
//                                 <span className="fw-bold text-success ">
//                                   {item?.DisplayAmt}
//                                 </span>
//                               </div>
//                               <div className="cr-right text-success">
//                                 <span className="text-success">
//                                   Your Current Rank{" "}
//                                   <strong>{item?.RankName}</strong>
//                                 </span>
//                                 <p className="text-success">{item?.Remark}</p>
//                               </div>
//                             </li>
//                             <li className="sm" key={index}>
//                               <div className="sm-div">
//                                 <div className="sm-left">
//                                   <div className="lakh ">
//                                     <span>
//                                       {convertToINRFormat(item?.TargetAmt)}
//                                     </span>
//                                     <span className="bg">
//                                       {convertToINRFormat(
//                                         parseInt(item?.TotalBusiAchived),
//                                       )}
//                                     </span>
//                                   </div>
//                                   <p className="headingColor">
//                                     <strong>{item?.RankName}</strong>{" "}
//                                     <span>{item?.Remark}</span>{" "}
//                                     {convertToINRFormat(
//                                       parseInt(item?.TotalBusiAchived),
//                                     )}{" "}
//                                     <span className="headingColor">
//                                       Total Business Achieved
//                                     </span>
//                                   </p>
//                                 </div>
//                                 <div className="sm-right">
//                                   <span>
//                                     {convertToINRFormat(
//                                       parseInt(item?.RequiredBusiness),
//                                     )}
//                                   </span>
//                                   <div className="more-next">
//                                     More to Achieve NEXT
//                                   </div>
//                                 </div>
//                               </div>
//                             </li>
//                           </>
//                         )
//                       );
//                     })
//                   : !loading && (
//                       <p className="p fs-6 text-danger text-center">
//                         No Record Found :)
//                       </p>
//                     )}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default MyRankOrg;import React, { useState } from "react";

import Loader from "../../../../../CommonComponets/Loader";
import useApiRequest from "../../../../../Hooks/apiReq";
import styles from "./MyRank.module.css";
import { useState } from "react";
import MyRankSkeleton from "./RankSkeleton";

const MyRankOrg = () => {
  console.log(styles?.cont, "styles");
  console.log(document.getElementsByClassName("_cont_1ftyn_1")[0]);
  const [myRanksData, setMyRank] = useState([
    {
      RankId: 1,

      RankName: "Associate",

      TargetAmt: 0.0,

      Status: "Achived",

      TotalBusiAchived: 0.0,

      RequiredBusiness: 0.0,

      Remark: "Your journey begins!",

      DisplayAmt: "Nil",

      DaysLimit: "No Time Limit",
    },

    {
      RankId: 2,

      RankName: "Qualifier",

      TargetAmt: 2500000.0,

      Status: "Achived",

      TotalBusiAchived: 0.0,

      RequiredBusiness: 0.0,

      Remark: "You are in the game!",

      DisplayAmt: "25 Lakh",

      DaysLimit: "No Time Limit",
    },

    {
      RankId: 3,

      RankName: "ASM",

      TargetAmt: 5000000.0,

      Status: "Active",

      TotalBusiAchived: 3500000.0,

      RequiredBusiness: 1500000.0,

      Remark: "Leveling up fast!",

      DisplayAmt: "50 Lakh",

      DaysLimit: "90 Days",
    },

    {
      RankId: 4,

      RankName: "SM",

      TargetAmt: 15000000.0,

      Status: "Pending",

      TotalBusiAchived: 0.0,

      RequiredBusiness: 0.0,

      Remark: "Power moves ahead!",

      DisplayAmt: "1.5 Cr.",

      DaysLimit: "270 Days",
    },

    {
      RankId: 5,

      RankName: "SSM",

      TargetAmt: 40000000.0,

      Status: "Pending",

      TotalBusiAchived: 0.0,

      RequiredBusiness: 0.0,

      Remark: "Just small push, & you are leveling up!",

      DisplayAmt: "4 Cr.",

      DaysLimit: "450 Days",
    },

    {
      RankId: 6,

      RankName: "AZM",

      TargetAmt: 100000000.0,

      Status: "Pending",

      TotalBusiAchived: 0.0,

      RequiredBusiness: 0.0,

      Remark: "Momentum is yours!",

      DisplayAmt: "10 Cr.",

      DaysLimit: "630 Days",
    },

    {
      RankId: 7,

      RankName: "ZM",

      TargetAmt: 250000000.0,

      Status: "Pending",

      TotalBusiAchived: 0.0,

      RequiredBusiness: 0.0,

      Remark: "Big leagues ahead!",

      DisplayAmt: "25 Cr.",

      DaysLimit: "900 Days",
    },

    {
      RankId: 8,

      RankName: "AGM",

      TargetAmt: 500000000.0,

      Status: "Pending",

      TotalBusiAchived: 524201081.85,

      RequiredBusiness: 475798918.14,

      Remark: "Leadership unlocked!",

      DisplayAmt: "50 Cr.",

      DaysLimit: "1260 Days",
    },

    {
      RankId: 9,

      RankName: "GM",

      TargetAmt: 1000000000.0,

      Status: "Pending",

      TotalBusiAchived: 0.0,

      RequiredBusiness: 0.0,

      Remark: "Master of the game!",

      DisplayAmt: "100 Cr.",

      DaysLimit: "1825 Days",
    },

    {
      RankId: 10,

      RankName: "Asst. Director",

      TargetAmt: 2000000000.0,

      Status: "Pending",

      TotalBusiAchived: 0.0,

      RequiredBusiness: 0.0,

      Remark: "Elite status loading!",

      DisplayAmt: "200 Cr.",

      DaysLimit: "2555 Days",
    },

    {
      RankId: 11,

      RankName: "Director",

      TargetAmt: 5000000000.0,

      Status: "Pending",

      TotalBusiAchived: 0.0,

      RequiredBusiness: 0.0,

      Remark: "One step from legend!",

      DisplayAmt: "500 Cr.",

      DaysLimit: "3285 Days",
    },

    {
      RankId: 12,

      RankName: "Executive Director",

      TargetAmt: 10000000000.0,

      Status: "Pending",

      TotalBusiAchived: 0.0,

      RequiredBusiness: 0.0,

      Remark: "You have made history!",

      DisplayAmt: "1000 Cr.",

      DaysLimit: "4380 Days",
    },
  ]);

  const { loading } = useApiRequest();
  if (loading) return <MyRankSkeleton />;

  // Current rank logic (e.g., Rank 8 is current)
  const currentRankId = 8;
  const cont = {};
  return (
    <div className={styles?.container11}>
      <div id="cont">
        <h1 className={styles.title}>Your journey is unstoppable</h1>
        <p className={styles.subtitle}>
          Next success is just a few steps away!
        </p>
      </div>
      <div className={styles.container12}>
        {myRanksData.map((item, index) => {
          const isCurrent = item.RankId === currentRankId;
          const isAchieved = item.RankId < currentRankId;
          const isLast = index === myRanksData.length - 1;

          return (
            <div
              key={item.RankId}
              className={`${styles.timelineItem} ${isCurrent ? styles.activeItem : ""}`}
            >
              {/* Left Side: Target Amount */}
              <div
                className={`${styles.targetSide} ${isAchieved ? styles.achievedText : ""}`}
              >
                <span className={styles.amountLabel}>{item.DisplayAmt}</span>
              </div>

              {/* Center Column: Node & Line */}
              <div className={styles.nodeSide}>
                {!isLast && (
                  <div
                    className={`${styles.verticalLine} ${isAchieved ? styles.lineAchieved : ""}`}
                  ></div>
                )}
                <div
                  className={`${styles.dot} ${isCurrent ? styles.dotCurrent : isAchieved ? styles.dotAchieved : styles.dotPending}`}
                >
                  {isAchieved && <span className={styles.checkIcon}>✓</span>}
                  {isCurrent && <div className={styles.dotInner}></div>}
                </div>
              </div>

              {/* Right Side: Info */}
              <div className={styles.infoSide}>
                <div
                  className={`${styles.rankName} ${isCurrent ? styles.activeText : ""}`}
                >
                  {item.RankName}
                </div>
                <div className={styles.remark}>{item.Remark}</div>

                {isCurrent && (
                  <div className={styles.progressCard}>
                    <div className={styles.progressLeft}>
                      <div className={styles.badgeRow}>
                        <span className={styles.badgeTarget}>
                          Target: ₹{item.TargetAmt.toLocaleString()}
                        </span>
                        <span className={styles.badgeAchieved}>
                          Achieved: ₹{item.TotalBusiAchived.toLocaleString()}
                        </span>
                      </div>
                      <p className={styles.progressLabel}>
                        Keep going! You've secured{" "}
                        <strong>
                          ₹{item.TotalBusiAchived.toLocaleString()}
                        </strong>{" "}
                        in total business.
                      </p>
                    </div>
                    <div className={styles.progressRight}>
                      <span className={styles.remainingAmt}>
                        ₹{item.RequiredBusiness.toLocaleString()}
                      </span>
                      <span className={styles.remainingText}>
                        Remaining to Reach Next
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MyRankOrg;
